<template>
	<section class="container-title " :id="[index]">
		<img :src="`${titleData.config.titleImage}`" alt="" />
		<div class="title-headline">
			<h1>{{ titleData.config.objectTitle }}</h1>
		</div>
	</section>
</template>
    
<script>
export default {
	props: {
		titleData: {
			type: Object
		},
		index: {
			type: Number
		}
	},
};</script>

<style lang="scss" scoped>
@import "@/assets/scss/design-wien/titleComponent.scss";
</style>
